import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'

const _4ff4a084 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _229617d4 = () => interopDefault(import('..\\pages\\reimbursement\\index.vue' /* webpackChunkName: "pages_reimbursement_index" */))
const _7ee0c23f = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _d2de7704 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _03378246 = () => interopDefault(import('..\\pages\\enroll\\eligibility.vue' /* webpackChunkName: "pages_enroll_eligibility" */))
const _4d2a1b98 = () => interopDefault(import('..\\pages\\enroll\\patient-information.vue' /* webpackChunkName: "pages_enroll_patient-information" */))
const _2d1c9064 = () => interopDefault(import('..\\pages\\enroll\\prescriber-information.vue' /* webpackChunkName: "pages_enroll_prescriber-information" */))
const _9f1b675a = () => interopDefault(import('..\\pages\\enroll\\success.vue' /* webpackChunkName: "pages_enroll_success" */))
const _7e139fdf = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _7e21b760 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _7e3de662 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _7e4bfde3 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _9a0c49c0 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _d780dcf0 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

Vue.use(Router)

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'

    // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.
    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto'
    })

    // Setting scrollRestoration to manual again when returning to this page.
    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual'
    })
  }
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected and scrollToTop is not explicitly disabled
  if (
    to.matched.length < 2 &&
    to.matched.every(r => r.components.default.options.scrollToTop !== false)
  ) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise((resolve) => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('#{BasePath}#/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,

    routes: [{
      path: "/error",
      component: _4ff4a084,
      name: "error"
    }, {
      path: "/reimbursement",
      component: _229617d4,
      name: "reimbursement"
    }, {
      path: "/rejection",
      component: _7ee0c23f,
      name: "rejection"
    }, {
      path: "/unlock",
      component: _d2de7704,
      name: "unlock"
    }, {
      path: "/enroll/eligibility",
      component: _03378246,
      name: "enroll-eligibility"
    }, {
      path: "/enroll/patient-information",
      component: _4d2a1b98,
      name: "enroll-patient-information"
    }, {
      path: "/enroll/prescriber-information",
      component: _2d1c9064,
      name: "enroll-prescriber-information"
    }, {
      path: "/enroll/success",
      component: _9f1b675a,
      name: "enroll-success"
    }, {
      path: "/errors/400",
      component: _7e139fdf,
      name: "errors-400"
    }, {
      path: "/errors/401",
      component: _7e21b760,
      name: "errors-401"
    }, {
      path: "/errors/403",
      component: _7e3de662,
      name: "errors-403"
    }, {
      path: "/errors/404",
      component: _7e4bfde3,
      name: "errors-404"
    }, {
      path: "/errors/500",
      component: _9a0c49c0,
      name: "errors-500"
    }, {
      path: "/",
      component: _d780dcf0,
      name: "index"
    }],

    fallback: false
  })
}
